import { Component, ElementRef, EventEmitter, Output, Input, ViewEncapsulation, Renderer2, AfterContentChecked, OnInit } from '@angular/core';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';

const BREAK_LARGE_RESOLUTION = 884;

@Component({
    selector: 'tidy-wrapper',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./wrapper.component.scss'],
    template: `
    <ng-content></ng-content>
  `,
    standalone: false
})

export  class WrapperComponent implements AfterContentChecked, OnInit {

  _contentHeight;
  @Output() contentHeight: EventEmitter<number> = new EventEmitter<number>();
  @Input() hasBottomNav = false;
  @Input() isMenu = false;
  @Input() isPrimaryLayer = false;

  constructor(
    private el : ElementRef,
    private renderer : Renderer2,
    private storage: TidyStorage,
    private windowService: WindowService
  ) {
  }

  ngOnInit() {
    localStorage.setItem('isPrimaryLayer', this.isPrimaryLayer ? 'true' : 'false');
  }

  ngAfterContentChecked() {
    const elementHeight = this.el.nativeElement.offsetHeight;
    if(this._contentHeight !== elementHeight) {
      this._contentHeight = elementHeight;
      this.contentHeight.emit(this._contentHeight);
      this.setPlatformClass();
    }
  }

  setPlatformClass(){
    if(this.isDesktopRes){
      this.renderer.addClass(this.el.nativeElement, 'desktop');
      this.renderer.removeClass(this.el.nativeElement, 'mobile');
    } else {
      this.renderer.addClass(this.el.nativeElement, 'mobile');
      this.renderer.removeClass(this.el.nativeElement, 'desktop');
    }
    if(this.hasBottomNav && !this.isDesktopRes){
      this.renderer.addClass(this.el.nativeElement, 'has-bottom-nav');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'has-bottom-nav');
    }
    if(this.isMenu){
      this.renderer.addClass(this.el.nativeElement, 'menu');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'menu');
    }
    const isSecondaryLayer = this.windowService?.isDesktopRes && !this.isPrimaryLayer && !this.isMenu;
    if (isSecondaryLayer) {
      this.renderer.addClass(this.el.nativeElement, 'modal');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'modal');
    }
  }

  public get isDesktopRes(): boolean {
    return this.windowService.windowSize > BREAK_LARGE_RESOLUTION;
  }
}
